var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnsimilar = function SvgUnsimilar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 10,
    x: 1,
    y: 1,
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 2,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#c1c1c1",
    strokeWidth: 1.5,
    d: "m4 8 3 3M5 5l6 6M8 4l4 4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 10,
    x: 4,
    y: 4,
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 2,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff553d",
    strokeWidth: 1.5,
    d: "m15 10-5 5M10 10l5 5"
  })));
};
export default SvgUnsimilar;